export default "__VITE_ASSET__4f9cf97d__"